"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function DotJoined(_ref) {
  var children = _ref.children,
      _ref$separator = _ref.separator,
      separator = _ref$separator === void 0 ? ' • ' : _ref$separator;

  var ch = _react.default.Children.toArray(children).filter(Boolean);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ch.map(function (c, i) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: i.toString()
    }, c, i < ch.length - 1 ? separator : '');
  }));
}

process.env.NODE_ENV !== "production" ? DotJoined.propTypes = {
  children: _propTypes.default.node,
  separator: _propTypes.default.string
} : void 0;
DotJoined.displayName = 'DotJoined';
var _default = DotJoined;
exports.default = _default;